import * as S from "./styles";
import LogoSOS from "../../../images/logo_craques_enem.png";

const SimulatedHeader = ({ simulated, title = "Simulado" }) => {
  const getCurrentDayOfWeek = () => {
    const separated = simulated.slug.split("-");
    const date = `${separated[separated.length - 3]}-${separated[separated.length - 1]}-${separated[separated.length - 2]} 04:00:00`;

    const daysOfWeek = [
      "Domingo",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado",
    ];
    const today = new Date(date);
    const dayOfWeek = today.getDay();

    return `${daysOfWeek[dayOfWeek]} | ${separated[separated.length - 2]}/${separated[separated.length - 1]}`;
  };

  return (
    <S.Container>
      <S.Logo src={LogoSOS} alt="Logotipo do Craques do ENEM" />
      <S.HeaderTitle>{title}</S.HeaderTitle>
    </S.Container>
  );
};

export default SimulatedHeader;
